/**
 * safePath.js — PROD-1313. One place that decides whether a value may be handed to
 * react-router's navigate() / <Link to> as a destination.
 *
 * react-router 6.x resolves a path with a backslash ("/\evil.com") the way a browser does, so it
 * can become the protocol-relative URL "//evil.com", an open redirect. A destination that came
 * from history state, a query string or the store is therefore accepted only when it is a
 * same-origin in-app path: exactly one leading "/", no backslash, no control character, no "//",
 * no scheme. Anything else becomes `fallback`.
 *
 * ★ NO IMPORTS, so scripts/check-safe-path.mjs executes it in plain node.
 */
export function safePath(p, fallback = '/home') {
  if (typeof p !== 'string') return fallback
  if (p.length < 1 || p.length > 2048) return fallback
  if (p[0] !== '/' || p[1] === '/' || p[1] === '\\') return fallback
  // eslint-disable-next-line no-control-regex
  if (/[\\\u0000-\u001f\u007f]/.test(p)) return fallback
  if (/^\/[a-z][a-z0-9+.-]*:/i.test(p)) return fallback
  if (p.split(/[?#]/)[0].includes('//')) return fallback
  return p
}
